import React, { useReducer } from "react";
import {
  CLEAR_FOLLOW_UPS,
  GET_FOLLOW_UP,
  GET_FOLLOW_UPS,
  SET_FOLLOW_UP_PAGINATION,
  SET_LOADING,
} from "../types";
import FollowUpContext from "./followUpContext";
import FollowUpReducer from "./followUpReducer";
import storage from "../../helpers/storage";
import axiosInstance from "../../services/axios.service";

// GET    /follow-ups?participant=&event=&outcome=&_limit=&_page=
// GET    /follow-ups/:id
// POST   /follow-ups   { participant, followUpDate, outcome, method, note }
//
// Paging and the outcome filter use the names the API reads. `status`,
// `limit` and `page` were sent instead, so filtering matched nothing and
// the page size was ignored.
const FollowUpState = (props) => {
  const initialState = {
    followUps: [],
    followUp: {},
    followUpPagination: {},
    loading: false,
  };

  const [state, dispatch] = useReducer(FollowUpReducer, initialState);

  const setLoading = () => {
    dispatch({
      type: SET_LOADING,
    });
  };

  const getFollowUps = async ({
    participant,
    event,
    outcome,
    limit = 30,
    page = 1,
  } = {}) => {
    const params = new URLSearchParams();
    if (participant) params.append("participant", participant);
    if (event) params.append("event", event);
    if (outcome) params.append("outcome", outcome);
    params.append("_limit", limit);
    params.append("_page", page);
    params.append("_order", "desc");
    params.append("_orderBy", "followUpDate");

    setLoading();
    try {
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/follow-ups?${params.toString()}`,
        storage.getConfigWithBearer()
      );

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: SET_FOLLOW_UP_PAGINATION,
        payload: paginate,
      });

      dispatch({
        type: GET_FOLLOW_UPS,
        payload: resp.data.data.docs,
      });
    } catch (error) {
      console.error("Error in getFollowUps:", error);
      dispatch({
        type: GET_FOLLOW_UPS,
        payload: [],
      });
    }
  };

  const getFollowUp = async (id) => {
    setLoading();
    try {
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/follow-ups/${id}`,
        storage.getConfigWithBearer()
      );

      dispatch({
        type: GET_FOLLOW_UP,
        payload: resp.data.data,
      });
    } catch (error) {
      console.error("Error in getFollowUp:", error);
    }
  };

  const createFollowUp = async (payload) => {
    setLoading();
    try {
      const resp = await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}/follow-ups`,
        payload,
        storage.getConfigWithBearer()
      );

      return { success: true, data: resp.data.data };
    } catch (error) {
      console.error("Error in createFollowUp:", error);
      return { success: false, error };
    }
  };

  const clearFollowUps = () => {
    dispatch({
      type: CLEAR_FOLLOW_UPS,
    });
  };

  return (
    <FollowUpContext.Provider
      value={{
        followUps: state.followUps,
        followUp: state.followUp,
        followUpPagination: state.followUpPagination,
        loading: state.loading,
        getFollowUps,
        getFollowUp,
        createFollowUp,
        clearFollowUps,
      }}
    >
      {props.children}
    </FollowUpContext.Provider>
  );
};

export default FollowUpState;
